import React, { ReactElement } from "react";
import { Box, Chip, Paper, Stack, Typography } from "@mui/material";

interface MRPCSamplesProps {
  sampleSelectedCallback?: (sentence1: string, sentence2: string) => void;
}

const Samples = (props: MRPCSamplesProps): ReactElement => {
  const { sampleSelectedCallback } = props;

  const getLabelText = (label: string): string => {
    return label === "LABEL_1" ? "Paraphrases" : "Not paraphrases";
  };

  const SAMPLES: { sentence1: string; sentence2: string; label: string }[] = [
    { sentence1: "A empresa anunciou que vai lançar um novo modelo de smartphone na próxima semana.", sentence2: "Um novo telemóvel será lançado pela companhia na semana que vem.", label: "LABEL_1" },
    { sentence1: "O trânsito na ponte ficou congestionado devido ao acidente matinal.", sentence2: "O acidente ocorrido de manhã provocou filas na ponte.", label: "LABEL_1" },
    { sentence1: "O atleta terminou a maratona em duas horas e dez minutos.", sentence2: "O corredor completou a prova em quase três horas.", label: "LABEL_0" },
    { sentence1: "As previsões meteorológicas indicam chuva forte para amanhã.", sentence2: "O céu estará limpo e as temperaturas vão subir no fim de semana.", label: "LABEL_0" },
    { sentence1: "O projeto de lei foi aprovado pelo parlamento e entrará em vigor em breve.", sentence2: " Os deputados deram luz verde à nova legislação, que será aplicada em breve.", label: "LABEL_1" },
  ];

  return (
    <>
      {SAMPLES.map((sample, index) => {
        return (
          <Paper
            key={"sample-" + index}
            variant="elevation"
            elevation={4}
            sx={{
              padding: "8px",
              marginBottom: "10px",
              border: "1px solid",
              borderColor: "primary.light",
              backgroundColor: "background.paper",
              cursor: "pointer",
              transition: "box-shadow 0.2s ease, transform 0.2s ease",
              "&:hover": {
                boxShadow: 6,
                transform: "translateY(-2px)",
              },
            }}
            onClick={() => {
              sampleSelectedCallback &&
                sampleSelectedCallback(sample.sentence1, sample.sentence2);
            }}
          >
            <Stack spacing={1.5}>
              <Chip
                label={sample.label + " · " + getLabelText(sample.label)}
                color={sample.label === "LABEL_1" ? "success" : "default"}
                variant={sample.label === "LABEL_1" ? "filled" : "outlined"}
                size="small"
                sx={{ alignSelf: "flex-start", fontWeight: 700 }}
              />
              <Box>
                <Typography
                  variant="caption"
                  sx={{ fontWeight: 700, color: "primary.main" }}
                >
                  Sentence 1
                </Typography>
                <Typography variant="body2">{sample.sentence1}</Typography>
              </Box>
              <Box>
                <Typography
                  variant="caption"
                  sx={{ fontWeight: 700, color: "primary.main" }}
                >
                  Sentence 2
                </Typography>
                <Typography variant="body2">{sample.sentence2}</Typography>
              </Box>
            </Stack>
          </Paper>
        );
      })}
    </>
  );
};

export default Samples;
